import * as React from 'react';
import clsx from 'clsx';

import BallPulse from './BallPulse';
import LoadingBar from './LoadingBar';
import Spinner from './Spinner';

export type LoadingPosition = 'FIXED' | 'INLINE' | 'INLINE-FULL';

export interface LoadingComponentProps {
  children?: React.ReactNode;
  containerClassName?: string;
  'data-testid'?: string;
  showOverlay?: boolean;
  isLoading?: boolean;
  isLoadingBar?: boolean;
  isBallPulse?: boolean;
  isJustOverlay?: boolean;
  loadingClassName?: string;
  loadingContainerClassName?: string;
  spinnerClassName?: string;
  spinnerText?: string;
  position?: LoadingPosition;
  /**
   * Added to support Emotion css prop - should not be used directly
   */
  className?: string;
  legacyRef?: React.LegacyRef<HTMLDivElement>;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export default class LoadingComponent extends React.PureComponent<LoadingComponentProps> {
  static defaultProps: Partial<LoadingComponentProps> = {
    spinnerClassName: 'Spinner',
  };

  render() {
    const {
      children,
      containerClassName,

      showOverlay,
      isJustOverlay,
      isLoading,
      isLoadingBar,
      isBallPulse,
      loadingClassName,
      loadingContainerClassName,
      spinnerClassName,
      spinnerText,
      position,
      className: classNameProp,
      legacyRef,
    } = this.props;

    const loadingContainerClass = isLoading ? loadingContainerClassName : '';
    const className = clsx(
      'LoadingComponent',
      classNameProp,
      containerClassName,
      loadingContainerClass,
      {
        'is-overlay': showOverlay && isLoading,
      }
    );
    const spinnerContextClass = clsx(
      'LoadingComponent-spinner',
      spinnerClassName,
      loadingClassName
    );
    const isSpinner = !isLoadingBar && !isBallPulse;
    const showChildren = showOverlay || !isLoading;
    return (
      <div className={className} data-testid={this.props['data-testid']} ref={legacyRef}>
        {!isJustOverlay && isLoading && isSpinner && (
          <Spinner
            contextClassName={spinnerContextClass}
            text={spinnerText}
            data-testid="loading-spinner"
          />
        )}
        {!isJustOverlay && isLoading && isLoadingBar && (
          <LoadingBar
            position={position}
            contextClassName={spinnerContextClass}
            data-testid="loading-ballpulse"
          />
        )}
        {!isJustOverlay && isLoading && isBallPulse && (
          <BallPulse
            contextClassName={spinnerContextClass}
            position={position}
            data-testid="loading-ballpulse"
          />
        )}
        {isJustOverlay && isLoading && (
          <div className={spinnerContextClass} data-testid="loading-overlay"></div>
        )}

        {showChildren && children}
      </div>
    );
  }
}
